export default "__VITE_ASSET__B23IZQsZ__"